import { render, staticRenderFns } from "./TenderDetail.vue?vue&type=template&id=f6cb5870&scoped=true"
import script from "./TenderDetail.vue?vue&type=script&lang=js"
export * from "./TenderDetail.vue?vue&type=script&lang=js"
import style0 from "./TenderDetail.vue?vue&type=style&index=0&id=f6cb5870&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6cb5870",
  null
  
)

export default component.exports